<template>
  <v-card>
    <v-card-title primary-title>
      <div>
        <div class="headline secondary--text">
          {{ $t('screener.monetization.all_payouts.title') }}
        </div>
        <span class="body-1 greyDarken1--text">{{
          $t('screener.monetization.all_payouts.subtitle')
        }}</span>
      </div>
    </v-card-title>
    <!-- <v-card-text class="px-0"> -->
    <v-layout row wrap class="pa-3">
      <v-flex xs12 sm12 md12 pl-2>
        <v-layout row wrap>
          <v-flex xs12 sm12 md6>
            <!-- <v-menu
                v-model="fromDateMenu"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                color="primary"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fromDate"
                    label="Start Date"
                    readonly
                    color="primary"
                    v-on="on"
                    clearable
                    class="mr-0 pr-0"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fromDate"
                  color="primary"
                  :show-current="new Date().toISOString().substr(0, 10)"
                  @input="fromDateMenu = false"
                ></v-date-picker> </v-menu
            ></v-flex>
            <v-flex xs12 sm12 md4 pl-2>
              <v-menu
                class="d-flex"
                v-model="toDateMenu"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                color="primary"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="toDate"
                    label="End Date"
                    readonly
                    color="primary"
                    v-on="on"
                    clearable
                    :rules="
                      fromDate
                        ? [
                            rules.greaterThanDate(
                              fromDate,
                              toDate
                            ),
                          ]
                        : []
                    "
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="toDate"
                  color="primary"
                  :show-current="new Date().toISOString().substr(0, 10)"
                  @input="toDateMenu = false"
                ></v-date-picker> </v-menu
            > -->
            <v-layout row wrap>
              <v-flex xs12 sm6 md6 pr-2>
                <v-select
                  v-model="type"
                  :items="types"
                  item-text="name"
                  item-value="value"
                  :label="$t('payout.label.select.type')"
                  return-object
                  color="primary"
                  @change="getPayoutsFromApi"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md6 pr-2>
                <v-select
                  v-model="status"
                  :items="statusNames"
                  item-text="name"
                  item-value="value"
                  :label="$t('payout.label.select.status')"
                  return-object
                  color="primary"
                  @change="getPayoutsFromApi"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm12 md6 pr-2>
            <v-layout row wrap class="text-xs-right">
              <v-flex xs12 sm12 md10>Payout (Income) </v-flex>
              <v-flex xs12 sm12 md2>
                {{ getCurrencySymbol(company.currency) }}&nbsp;{{ payout_sum }}
              </v-flex>
            </v-layout>
            <v-layout row wrap class="text-xs-right">
              <v-flex xs12 sm12 md10
                >Other Costs (Expense)
                <h6>Refund cost/Dispute Penalty/Adjustment</h6></v-flex
              >
              <v-flex xs12 sm12 md2>
                {{ getCurrencySymbol(company.currency) }}&nbsp;{{ cost_sum }}
              </v-flex>
            </v-layout>
            <v-divider inset></v-divider>
            <v-layout row wrap class="text-xs-right">
              <v-flex xs12 sm12 md10>Total Paid</v-flex>
              <v-flex xs12 sm12 md2>
                {{ getCurrencySymbol(company.currency) }}&nbsp;{{
                  (parseFloat(payout_sum) + parseFloat(cost_sum)).toFixed(2)
                }}
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-data-table
      :headers="table_headers"
      :loading="loading"
      :items="payouts"
      :pagination.sync="pagination"
      :total-items="total"
      :rowsPerPageItems="rowsPerPageItems"
      item-key="id"
    >
      <template
        slot="headerCell"
        slot-scope="props"
        v-if="
          props.header.value != 'admin_note' ||
            user_role == DEFINES.USER_ROLE_SUPER_ADMIN
        "
      >
        <v-tooltip top v-if="props.header.tooltip" color="greyDarken1">
          <template v-slot:activator="{on}">
            <span v-on="on">{{ props.header.text }}</span>
          </template>
          <span class="white--text body-1" v-html="props.header.tooltip"></span>
        </v-tooltip>
        <span v-else>{{ props.header.text }}</span>
      </template>
      <template v-slot:items="props">
        <tr>
          <td>
            {{ DEFINES.MONETIZATION.PAYOUT_TYPE[props.item.type] }}
            <span v-if="props.item.type === 10" class="success--text"
              ><br />(Income)</span
            >
            <span v-else class="error--text"><br />(Expense)</span>
          </td>
          <td>
            <span
              :class="
                props.item.status == 40 ? 'success--text' : 'warning--text'
              "
            >
              {{ DEFINES.MONETIZATION.PAYOUT_STATUS[props.item.status] }}
              <v-tooltip
                slot="append"
                top
                color="white"
                v-if="props.item.status != 40 && props.item.status != 30"
              >
                <v-btn
                  slot="activator"
                  icon
                  @click.stop="enablePayoutRequestDialog(props.item)"
                  small
                  dark
                >
                  <v-icon color="primary">$vuetify.icons.rms_edit</v-icon>
                </v-btn>
                <span class="greyDarken3--text body-1">{{
                  $t('rms.tooltip.edit')
                }}</span>
              </v-tooltip>
            </span>
          </td>
          <td
            :class="
              (props.item.amount >= 0 && props.item.type === 10) ||
              (props.item.amount < 0 && props.item.type != 10)
                ? 'success--text'
                : 'error--text'
            "
          >
            {{ getCurrencySymbol(company.currency) }}
            {{ parseFloat(props.item.amount) }}
          </td>
          <td>{{ fmtTime(props.item.created_at) }}</td>
          <td>
            <router-link
              :to="{
                name: 'purchase.detail',
                params: {purchase_id: props.item.purchase_id},
              }"
              >{{ props.item.purchase_id }}</router-link
            >
          </td>
          <td>
            {{ props.item.client_note }}
          </td>
          <td v-if="user_role == DEFINES.USER_ROLE_SUPER_ADMIN">
            {{ props.item.admin_note }}
          </td>
        </tr>
      </template>
    </v-data-table>
    <!-- </v-card-text> -->
    <ConfirmPayout
      :status.sync="payout_status"
      :unpaid_amount="payout_amount"
      :currency_symbol="getCurrencySymbol(company.currency)"
      :client_note.sync="client_note"
      :admin_note.sync="admin_note"
      :type="payout_type"
      :showStatus="true"
      :btnText="$t('rms.button.update')"
      :dialog="showPayoutRequestDialog"
      @onCancel="resetPayoutRequest"
      @onConfirm="updatePayoutRequest"
    >
    </ConfirmPayout>
  </v-card>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
import DEFINES from '@/defines';
import {utcToTz, tzToUtc, getCurrencySymbol} from '@/helper';
import i18n from '@/i18n';
import rules from '@/validation';
import ConfirmPayout from '@/components/revenue/ConfirmPayout';

// Computed
const computed = {
  ...mapState({
    user_role: (state) => state.user.profile.role,
  }),
  ...mapState({
    company: (state) => state.company.company,
  }),
  ...mapGetters('company', {
    timezone: 'getSelectedCompanyTimezone',
  }),
};

// Methods
const methods = {
  applySearch() {
    if (this.search.length) this.getPayoutsFromApi();
  },
  clearSearch() {
    this.search = '';
    this.getPayoutsFromApi();
  },
  getCurrencySymbol(currency) {
    return getCurrencySymbol(currency);
  },
  // convert utc to comapny timezone
  fmtTime(input) {
    return utcToTz(input, this.timezone, 'Do MMM YYYY, h:mm a');
  },
  async getPayoutsFromApi() {
    try {
      this.loading = true;
      // Pagination
      const {sortBy, descending, page, rowsPerPage} = this.pagination;
      var offset = this.getPaginationOffset(rowsPerPage, page);
      // Payload
      let payload = {
        offset: offset,
        limit: rowsPerPage,
        sort: sortBy,
        sorting_order: descending,
        type: this.type ? this.type.value : null,
        status: this.status ? this.status.value : null,
        // search: this.search,
        // filters: this.filters,
      };

      var response = await this.$store.dispatch(
        'monetization/listPayouts',
        payload
      );
      this.total = response.payouts.total;
      this.payouts = response.payouts.data;
      this.loading = false;
      this.payout_sum = response.payouts.payout_sum;
      this.cost_sum = response.payouts.cost_sum;
    } catch (error) {
      this.loading = false;
      this.$store.dispatch('app/showMessage', {
        message: error.message,
        color: 'error',
      });
    }
  },

  async enablePayoutRequestDialog(payout) {
    this.showPayoutRequestDialog = true;
    this.payout_status = payout.status;
    this.client_note = payout.client_note;
    (this.admin_note = payout.admin_note), (this.payout_id = payout.id);
    this.payout_amount = payout.amount;
    this.payout_type = payout.type;
  },

  async updatePayoutRequest() {
    try {
      let payload = {
        payout_id: this.payout_id,
        client_note: this.client_note,
        admin_note: this.admin_note,
        status: this.payout_status,
      };
      await this.$store.dispatch('monetization/updatePayoutRequest', payload);
      this.getPayoutsFromApi();
    } catch (error) {
      this.$store.dispatch('app/showMessage', {
        message: error.message,
        color: 'error',
      });
    } finally {
      this.resetPayoutRequest();
    }
  },

  async resetPayoutRequest() {
    this.showPayoutRequestDialog = false;
    this.payout_status = null;
    this.client_note = null;
    this.admin_note = null;
    this.payout_id = null;
    this.payout_type = null;
    this.payout_amount = null;
  },

  getPaginationOffset: (recordPerPage, page) => recordPerPage * (page - 1),
};

export default {
  name: 'PayoutList',
  props: {
    selectedType: {
      type: String,
      default: null,
    },
    selectedStatus: {
      type: String,
      default: null,
    },
  },
  data: function() {
    return {
      rules,
      table_headers: [
        {
          text: i18n.t('screener.table.header.type'),
          sortable: true,
          align: 'left',
          value: 'type',
          tooltip: '',
        },
        {
          text: i18n.t('screener.table.header.status'),
          sortable: true,
          align: 'left',
          value: 'status',
          tooltip: '',
        },
        {
          text: i18n.t('screener.table.header.amount'),
          sortable: false,
          align: 'left',
          value: 'amount',
          tooltip: '',
        },
        {
          text: i18n.t('screener.table.header.created_at'),
          align: 'left',
          value: 'created_at',
          sortable: true,
          tooltip: '',
        },
        {
          text: i18n.t('screener.table.header.purchase_id'),
          sortable: true,
          align: 'left',
          value: 'purchase_id',
          tooltip: '',
        },
        {
          text: i18n.t('screener.table.header.client_note'),
          sortable: false,
          align: 'left',
          value: 'client_note',
          tooltip: '',
        },
        {
          text: i18n.t('screener.table.header.admin_note'),
          sortable: false,
          align: 'left',
          value: 'admin_note',
          tooltip: '',
        },
      ],
      rowsPerPageItems: [1, 5, 10, 25, 50, 100],
      pagination: {
        sortBy: 'created_at',
        descending: true,
        page: 1,
        rowsPerPage: 10,
      },
      loading: false,
      total: null,
      payout_sum: null,
      cost_sum: null,
      // fromDateMenu: false,
      // toDateMenu: false,
      // fromDate: null,
      // toDate: null,
      payouts: [],
      type: this.selectedType,
      types: [
        {
          name: i18n.t('payout.type.all'),
          value: null,
        },
        {
          name: i18n.t('screener.payout_type.client_payout'),
          value: DEFINES.MONETIZATION.PAYOUT.CLIENT_PAYOUT,
        },
        {
          name: i18n.t('screener.payout_type.refund_cost'),
          value: DEFINES.MONETIZATION.PAYOUT.REFUND_COST,
        },
        {
          name: i18n.t('screener.payout_type.dispute_from_client'),
          value: DEFINES.MONETIZATION.PAYOUT.DISPUTE_FROM_CLIENT,
        },
        {
          name: i18n.t('screener.payout_type.adjustment'),
          value: DEFINES.MONETIZATION.PAYOUT.ADJUSTMENT,
        },
      ],
      status: this.selectedStatus,
      statusNames: [
        {
          name: i18n.t('payout.type.all'),
          value: null,
        },
        {
          name: i18n.t('screener.payout_status.requested'),
          value: DEFINES.MONETIZATION.PAYOUT_STATUS_NAMES.REQUESTED,
        },
        {
          name: i18n.t('screener.payout_status.in_process'),
          value: DEFINES.MONETIZATION.PAYOUT_STATUS_NAMES.IN_PROCESS,
        },
        {
          name: i18n.t('screener.payout_status.rejected'),
          value: DEFINES.MONETIZATION.PAYOUT_STATUS_NAMES.REJECTED,
        },
        {
          name: i18n.t('screener.payout_status.completed'),
          value: DEFINES.MONETIZATION.PAYOUT_STATUS_NAMES.COMPLETED,
        },
      ],
      showPayoutRequestDialog: false,
      payout_status: null,
      client_note: null,
      admin_note: null,
      payout_id: null,
      payout_type: null,
      payout_amount: null,
    };
  },
  components: {
    ConfirmPayout,
  },
  computed: computed,
  watch: {
    pagination: {
      handler: 'getPayoutsFromApi',
      deep: true,
    },
  },
  mounted() {
    this.getPayoutsFromApi();
  },
  methods: methods,
};
</script>

<style></style>
